import { apiClient } from "helpers/api_helper"
import { API } from "../constants/vendor.api";

export const getAllVendorList = async (data: object) => {
    try {
        const response = await apiClient.get(API.GET_VENDOR_LIST, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createVendor = async (data: object) => {
    try {
        const response = await apiClient.post(API.CREATE_VENDOR, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const updateVendor = async (data: object) => {
    try {
        const response = await apiClient.post(API.UPDATE_VENDOR, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getVendorById = async (id: any) => {
    try {
        const response = await apiClient.get(API.GET_VENDOR_BY_ID + '?id=' + id);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getVendorByMobileNo = async (mobileNo: any) => {
    try {
        const response = await apiClient.get(API.GET_VENDOR_BY_MOBILE_NO + '?mobileNo=' + mobileNo);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const deleteVendor = async (id: any) => {
    try {
        const response = await apiClient.delete(API.DELETE_VENDOR + '?id=' + id);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};